export enum DashboardRoute {
  DASHBOARD = '/dashboard',
  GANTT = '/planner',
  MAP = '/map',
  ORDERS = '/orders',
  DELEGATIONS = '/delegations',
  DRIVERS = '/drivers',
  FLEET = '/fleet',
  ADMIN_PANEL = '/admin-panel',
  MANAGEMENT_PANEL = '/management-panel',
  SETTINGS = '/settings',
}
